import { ElementType, useContext } from 'react';
import Scrollspy from '../Scrollspy';
import { DrawerContext } from '../../contexts/DrawerContext';
import NextImage from '../NextImage';

export interface MenuItem {
  id?: string | number;
  label: string;
  path: string;
  icon?: string;
  staticLink?: string;
  isCta?: boolean;
}

export interface ScrollSpyMenuProps {
  className?: string;
  menuItems: MenuItem[];
  drawerClose?: boolean;
  currentClassName?: string;
  scrolledPastClassName?: string;
  componentTag?: ElementType;
  style?: React.CSSProperties;
  rootEl?: string;
  onUpdate?: (item: HTMLElement) => void;
  offset?: number;
}

interface RenderLinkProps {
  menu: MenuItem;
}

const RenderLinkWithIcon = ({ menu }: RenderLinkProps) => (
  <div className="icon-login">
    {menu.icon ? (
      <NextImage className="icon" src={menu.icon} alt={menu.label} />
    ) : (
      ''
    )}
    <a className={menu.icon ? 'icon-label' : 'no-icon-label'} href={menu.path}>
      {menu.label}
    </a>
  </div>
);

const ScrollSpyMenu = ({
  className,
  menuItems,
  drawerClose,
  componentTag = 'ul',
  currentClassName = 'is-current',
  ...props
}: ScrollSpyMenuProps) => {
  // Subscribe to drawer context to keep parity with original behavior
  // (dispatch was previously declared but unused; left out here).
  useContext(DrawerContext);

  const scrollItems = menuItems.map((item) => item.path.slice(1));

  const addAllClasses = ['scrollspy__menu'];
  if (className) addAllClasses.push(className);

  return (
    <Scrollspy
      items={scrollItems}
      className={addAllClasses.join(' ')}
      currentClassName={currentClassName}
      componentTag={componentTag}
      {...(props as Record<string, unknown>)}
    >
      {menuItems.map((menu, index) => (
        <li key={`menu-item-${index}`}>
          <RenderLinkWithIcon menu={menu} />
        </li>
      ))}
    </Scrollspy>
  );
};

export default ScrollSpyMenu;
